<template>
    <div class="pa-0 px-3">
        <!-- Title with standard left padding -->
        <h2 class="pt-3 pb-2" style="letter-spacing:normal;">{{ this.pageTitle }}</h2>

        <!-- White card holding all content -->
        <div class="wizard-main-card">
        <v-toolbar flat class="mb-2">
            <v-spacer></v-spacer>
            <button type="button" class="export-icon-btn export-icon-csv mr-3" @click="getCSV" title="Export CSV">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="12" y1="18" x2="12" y2="12"/><polyline points="9 15 12 18 15 15"/></svg>
              CSV
            </button>
            <div class="gv-search">
                <svg class="gv-search-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#94A3B8" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round">
                    <circle cx="11" cy="11" r="8"/>
                    <line x1="21" y1="21" x2="16.65" y2="16.65"/>
                </svg>
                <input v-model="search" type="text" placeholder="Search..." class="gv-search-input" />
            </div>
        </v-toolbar>

        <v-data-table 
            dense :loading="loading"
            :headers="this.dataHeader"
            :items="this.wizardItems"
            :search="search"
            :items-per-page="10"
            class="elevation-0 font-weight-light text--secondary"
            style="font-size:small"
            multi-sort
            fixed-header
            item-key="wizardcode"
        >
            <template v-slot:body>
                    <tbody>
                        <tr v-for="item in wizardItems" :key="item">
                            <td @click="loadPageHandler(item.id)"> {{item.wizardcode}} </td>
                            <td>{{ item.wizarddesc }} </td>
                        </tr>  
                    </tbody>
              </template>

        </v-data-table>
         <div v-if="isErr">
                <app-error
                    v-bind:parentError="{
                    data: this.errMsg,
                    isErr: this.isErr,
                    }"
                    v-on:closeError="isErr = $event"
                />
      </div>
        </div><!-- end wizard-main-card -->
    </div> 
</template>

<script>
import ErrorDialog from "../../../components/common/ErrorDialog";

export default {
    props: {
        //parentData: Object,
        "app-error": ErrorDialog,
    },

    data() {
        return {
            pageTitle: this.$t('columns.wizardlist'),
            dataHeader: [
                { text: this.$t('columns.wizardname'), value: 'wizardcode', width: '100px' },
                { text: this.$t('columns.wizarddescription'), value: 'wizarddesc', width: '100px' },
            ],

            getid: this.$route.params.id,
            formData: {
                wizardcode: null,
                wizarddesc: null,
                userid: this.$store.getters.userId
            },

            
            wizardItems: [],
            dataItems: [],
            getId: [],
            loading: false,
            isErr: false,
            errMsg: '',
            search: '',

        };
    },

    methods: {

        onNewPressed() {
            this.$router.push({name: 'wizardnew'});
        },

        errorHandler($event) {
            this.isErr = $event.isErr;
            this.errMsg = $event.errMsg;
        },

        loadWizardList() {
            const vm = this;

            this.$store.dispatch('get', {url: '/wizardsetup/all'})
            .then (res => {
              
              vm.wizardItems = res.data.rec;
              vm.loading = false;
              console.log('wizard', vm.wizardItems)
            })
            .catch(err => {
                vm.isErr = true;
                vm.errMsg = err;
                vm.$emit('error', {isErr: vm.isErr, errMsg: vm.errMsg});
            })
        },

        loadPageHandler(id) {
            let wizard = this.getid           
            this.$router.push({name: 'wizardstep', params: {id, wizard}});
        },

         objectToCSV(data) {
             const csvRows = []
            
             //get header
             const headers = Object.keys(data[0])
             //const headers = this.titles
             csvRows.push(headers.join(','))
            
             //loop over the rows
             for (const row of data) {
                 const values = headers.map(header => {
                     const escaped = ('' + row[header]).replace(/"/g, '\\"')
                     return `"${escaped}"`
                 })
                 csvRows.push(values.join(','))
             }
             return csvRows.join('\n')
         },
             download(data) {
             const blob = new Blob([decodeURIComponent('%ef%bb%bf'), data], { type: 'text/csv;charset=utf-8;'})
             const url = window.URL.createObjectURL(blob)
             const a = document.createElement('a')
             a.setAttribute('hidden', '')
             a.setAttribute('href', url)
             a.setAttribute('download', this.pageTitle + '.csv')
             document.body.appendChild(a)
             a.click()
             document.body.removeChild(a)
         },
         async getCSV() {
             let titles = this.dataHeader
             let item = this.wizardItems
             let data = []
             let obj2 = {}
            
                 titles.forEach(element1 => {
                 let x = element1.text
                 obj2[x]= element1.value
                 });
                    
                 item.forEach(element1 => {
                     let obj = {}
                     titles.forEach(element2 => {
                         if(element2.value != 'action'){
                         let key = element2.text
                         obj[key] = element1[element2.value]
                         }
                     });
                         data.push(obj)
                 });
            
                 const csvData = this.objectToCSV(data)
                 this.download(csvData)             
        }       
    },

     mounted() {
     this.loadWizardList();
   },
};
</script>

<style scoped>
.wizard-main-card {
    background: #ffffff;
    border-radius: 16px;
    border: 1px solid #E8EDF5;
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
    padding: 8px 24px 24px 24px;
    margin-top: 4px;
    margin-bottom: 24px;
}
.export-icon-btn {
  display: inline-flex; align-items: center; gap: 6px;
  padding: 6px 14px; border-radius: 8px; border: none;
  font-size: 0.8rem; font-weight: 600; cursor: pointer;
  font-family: inherit; transition: all 0.15s;
}
.export-icon-csv { background: #ECFDF5; color: #059669; border: 1px solid #A7F3D0; }
.export-icon-csv:hover { background: #059669; color: #fff; }
.gv-search {
  position: relative;
  display: inline-flex;
  align-items: center;
}
.gv-search-icon {
  position: absolute;
  left: 8px;
  top: 50%;
  transform: translateY(-50%);
  pointer-events: none;
}
.gv-search-input {
  padding: 5px 10px 5px 30px;
  border: 1.5px solid #E8EDF5;
  border-radius: 8px;
  font-size: 0.83rem;
  font-family: inherit;
  color: #1E293B;
  outline: none;
  width: 220px;
  background: #fff;
}
.gv-search-input:focus {
  border-color: #4F6BFF;
  box-shadow: 0 0 0 3px rgba(79,107,255,0.10);
}
</style>